<template>
  <div>
    <div :class="$style.pwaBlock">
      <div :class="$style.pwaBlockHero">
        <img :class="$style.pwaBlockHeroBg" src="/images/pwa/img_bg.jpg" alt="" />
        <div :class="$style.pwaBlockHeroLeft">
          <h1 v-html="data.bannerTitle" />
          <p v-html="data.bannerText" />
          <div :class="$style.pwaBlockHeroBtns">
            <BitButton
              type="secondary"
              is-fluid-width
              no-margin
              @click="storeModals.openPwaInstallModal"
            >
              {{ storeButtonsTitle.installApp }}
            </BitButton>
            <ul>
              <li>
                <img src="/images/pwa/ico_android.svg" alt="" />
              </li>
              <li>
                <img src="/images/pwa/ico_apple.svg" alt="" />
              </li>
              <li>
                <img src="/images/pwa/ico_microsoft.svg" alt="" />
              </li>
            </ul>
          </div>
        </div>
        <div :class="$style.pwaBlockHeroRight">
          <picture>
            <source media="(max-width: 960px)" :srcset="data.bannerImageMobile.url" />
            <img :src="data.bannerImage.url" :alt="data.bannerTitle" />
          </picture>
        </div>
      </div>
      <div :class="$style.pwaBlockAdvantage">
        <div
          v-for="item in data.pwaAdvatagesBlock"
          :key="item.title"
          :class="$style.pwaBlockAdvantageItem"
        >
          <img :src="item.image.url" alt="" />
          <p :class="$style.pwaBlockAdvantageItemTitle">{{ item.title }}</p>
          <p :class="$style.pwaBlockAdvantageItemText" v-html="item.text" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { BitButton } from '@bit/ui-kit';
import { useStoreModals } from '~/stores/abstract/modals';
import { useStoreButtonTitles } from '~/stores/strapi/buttonTitles';
import type { ComponentInfoPageBlocksPwaBlock } from '~/types/infoPages';

defineProps({
  data: {
    type: Object as PropType<ComponentInfoPageBlocksPwaBlock>,
    required: true,
  },
});

const storeModals = useStoreModals();
const storeButtonsTitle = useStoreButtonTitles();
</script>

<style lang="scss" module src="./pwaBlock.scss"></style>
